import { render } from "./BaseTaxonDataTable.vue?vue&type=template&id=eeb6a06a"
import script from "./BaseTaxonDataTable.vue?vue&type=script&lang=js"
export * from "./BaseTaxonDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__